export default __webpack_public_path__ + "resources/icons/d230-904e.webp";